import DeclinedServicesListContainer from './DeclinedServicesListContainer';

export default DeclinedServicesListContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/DeclinedServicesList/index.js